import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  roomStreamToSubscribeVORaw,
  RoomStreamToSubscribeVORaw
} from "@youm-front/room/domain";

export class RoomStreamToSubscribeEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamToSubscribeEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamToSubscribeEventDTORaw) {
    JsonSchemaValidator.assert(RoomStreamToSubscribeEventDTO.validation, data);
  }

  private static validationSchema() {
    return roomStreamToSubscribeVORaw;
  }
}

export type RoomStreamToSubscribeEventDTORaw = RoomStreamToSubscribeVORaw;
